import { Dialog, DialogContent } from '@pocketlaw/tetris';
import { ComposerDataProvider } from './ComposerDataProvider';
import { Root } from './Root';
export function SelectTemplateDialog(props) {
    const { initialComposerId, initialParentId, onClose } = props;
    return (<Dialog size="xl" height="80dvh" onClose={onClose}>
      <DialogContent disablePadding>
        <ComposerDataProvider initialComposerId={initialComposerId} initialParentId={initialParentId} onClose={onClose}>
          <Root />
        </ComposerDataProvider>
      </DialogContent>
    </Dialog>);
}
